import type { App } from 'vue';
import BeamerClient from './beamer.ts';

const beamer = new BeamerClient();

const VueBeamer = {
    install(app: App) {
        app.config.globalProperties.$beamer = beamer;
    },
};

export default VueBeamer;
